<template>
  <div class="add-tag-wrap">
    <el-dialog
      :title="modalType === 'add' ? '新建标签' : '编辑标签'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="500px"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="90px" class="demo-dynamic">
        <el-form-item v-if="modalType === 'add'">
          <el-button @click="addItem" icon="el-icon-plus" style="width: 290px">添加标签</el-button>
        </el-form-item>
        <el-form-item
          label="一级标签："
          prop="firstTagId"
          v-if="tagType !== 'first'"
          :rules="{
            required: true,
            message: '请选择一级标签',
            trigger: 'blur',
          }"
        >
          <el-select style="width: 290px" v-model="ruleForm.firstTagId" placeholder="请选择一级标签">
            <el-option v-for="item in tagOptions" :key="item.name" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="二级标签："
          prop="secondTagId"
          v-if="tagType === 'third'"
          :rules="{
            required: true,
            message: '请选择二级标签',
            trigger: 'change',
          }"
        >
          <el-select style="width: 290px" v-model="ruleForm.secondTagId" placeholder="请选择二级标签">
            <el-option v-for="item in secondTagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <div class="content">
          <el-form-item
            label=" "
            class="label-body"
            prop="tagList"
            :rules="{
              required: true,
              trigger: 'blur',
              validator: labelValidator,
            }"
          >
            <el-form-item
              v-for="(item, index) in ruleForm.tagList"
              class="form-item marginLeft"
              :label="index === 0 ? '标签名称：' : ''"
              :key="index"
              :prop="'tagList.' + index + '.value'"
              :rules="{
                required: true,
                trigger: 'blur',
                message: '标签不能为空',
              }"
            >
              <el-input type="text" placeholder="请输入标签名" v-model="item.value" maxlength="20" show-word-limit></el-input>
              <i class="el-icon-delete icon" v-if="ruleForm.tagList.length > 1" @click.prevent="deleteItem(index)"></i>
            </el-form-item>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addTag, editTag, getSelectTagList } from "@/api/property.js";

export default {
  components: {},
  props: {
    tagOptions: Array,
  },
  data() {
    return {
      dialogVisible: false,
      secondTagOptions: [],
      ruleForm: {
        id: "",
        tagList: [{ value: "" }],
        firstTagId: "",
        secondTagId: "",
        thirdTagId: "",
      },
      tagType: "",
      modalType: "add",
      loading: false,
    };
  },

  computed: {},

  watch: {
    "ruleForm.firstTagId": {
      handler(val, oldval) {
        if (val) {
          getSelectTagList({
            dataLevel: 2,
            firstTagIds: val,
          }).then((res) => {
            this.secondTagOptions = res.data;
            if (oldval) {
              this.ruleForm.secondTagId = "";
            }
          });
        } else {
          this.secondTagOptions = [];
        }
      },
      deep: true,
    },
  },

  mounted() {},

  methods: {
    labelValidator(rule, value, callback) {
      const list = value.map((item) => item.value);
      if (new Set(list).size !== list.length && !list.includes("")) {
        callback(new Error("添加的标签不能重复"));
      } else {
        callback();
      }
    },
    openModal(type, modalType, data) {
      this.tagType = type;
      this.modalType = modalType;
      if (modalType == "add") {
        this.ruleForm = {
          tagList: [{ value: "" }],
          firstTagId: "",
          secondTagId: "",
        };
      } else {
        const { id, name, tagId1, tagId2, tagId3 } = data;
        this.ruleForm.id = id;
        this.ruleForm.firstTagId = tagId1;
        this.ruleForm.secondTagId = tagId2;
        this.ruleForm.thirdTagId = tagId3;
        this.ruleForm.tagList = [{ value: name }];
      }
      this.dialogVisible = true;
    },
    addItem() {
      this.ruleForm.tagList.push({ value: "" });
    },
    deleteItem(index) {
      this.ruleForm.tagList.splice(index, 1);
    },
    handleConfirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { tagList, firstTagId, secondTagId, id } = this.ruleForm;
          const arr = tagList.map((item) => item.value) || [];
          if (this.modalType == "add") {
            addTag({
              name: arr.join(","),
              dataLevel: this.tagType === "first" ? 1 : this.tagType === "second" ? 2 : 3,
              parentId: this.tagType === "first" ? 0 : this.tagType === "second" ? firstTagId : secondTagId,
            }).then((res) => {
              if (res.code === "0000") {
                this.$message.success("添加成功");
                this.dialogVisible = false;
                this.$emit("successCallBack");
              }
            });
          } else {
            editTag({
              name: arr.join(","),
              tagId2: secondTagId,
              tagId1: firstTagId,
              id,
              dataLevel: this.tagType === "first" ? 1 : this.tagType === "second" ? 2 : 3,
            }).then((res) => {
              if (res.code === "0000") {
                this.$message.success("编辑成功");
                this.dialogVisible = false;
                this.$emit("successCallBack");
              }
            });
          }
        } else {
          // this.$message.error("表单未填写完成");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.add-tag-wrap {
  .content {
    max-height: 500px;
    overflow: auto;
    margin-top: 12px;
    padding-right: 12px;
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(0, 0, 0, 0.2);
    }
    .label-body {
      /deep/ .el-form-item__content {
        margin-left: 0px !important;
      }
      /deep/ .el-form-item__error {
        margin-left: 90px;
      }
    }
    .marginLeft {
      /deep/ .el-form-item__content {
        margin-left: 90px !important;
      }
      /deep/ .el-form-item__error {
        margin-left: 0px;
      }
    }
    .form-item {
      /deep/ .el-input {
        width: 290px;
      }
      .icon {
        font-size: 20px;
        margin-left: 12px;
        margin-top: 7px;
        cursor: pointer;
      }
      .el-icon-delete {
        color: red;
      }
    }
  }
}
</style>
